import numeral from 'numeral';

export const formatMoney = (number) => {
    return numeral(number).format('$0,00.00');
};

export const formatMoneyFromPennies = (number) => {
    return numeral(number / 100.0).format('$0,00.00');
};